module.exports = __webpack_public_path__ + "static/media/sample-audio.0eb3f36b.mp3";